export const redirectLink={
    growthQuotations:"/partners/quotations",
    sourcingQuotations:"/request/quotations",
    productCatalog:"/catalog/catalogList"

}